import loadable from '@loadable/component'
import React from 'react'
import { Route, Switch } from 'react-router'

import HttpStatus from 'components/Common/HttpStatus'
import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'

const HeaderMain = loadable(
  () =>
    import(
      /* webpackChunkName: 'HeaderMain' */ '../../client/components/App/Header/HeaderMain/HeaderMain'
    ),
)

function Trip404Page() {
  return (
    <Switch>
      <Route exact path="/:regionCode/trip-planner/trip">
        <HttpStatus code={404}>
          <HeaderMain />
          <Error404PageWithOffers />
        </HttpStatus>
      </Route>
      <Route>
        <HttpStatus code={404}>
          <Error404PageWithOffers />
        </HttpStatus>
      </Route>
    </Switch>
  )
}

export default Trip404Page
